var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(`width: ${_vm.size}px; height: auto; object-fit: contain`),attrs:{"src":_vm.iconSrc,"id":_vm._uid},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }